import classNames from 'classnames';
import React, {PropTypes} from 'react';
// import FontAwesome from 'react-fontawesome';
import * as utils from '../common/utils';
import { Link } from 'react-router';
import Button from '../common/Button';
import PermissionLink from '../common/PermissionLink';

const ClubMemberRow = ({member, deleteMember, restoreMember}) => {
  // let iconColor = member.active ? 'member active text-success' : 'member inactive text-muted';
  // let checkIcon = member.active ? 'check-circle' : 'circle-o';
  let address = utils.join([member.address, member.zip,
    member.municipality, member.county, member.country], ", ");
  return (
    <tr>
      {/*<td><FontAwesome className={iconColor} name={checkIcon} /></td> */}
      <td>
        <Link to={'/klubb/' + member.club + '/medlem/' + member.id + '/rediger'}>
          {member.first_name}
        </Link>
      </td>
      <td>
        <Link to={'/klubb/' + member.club + '/medlem/' + member.id + '/rediger'}>
          {member.last_name}
        </Link>
      </td>
      <td className="hidden-xs">{member.phone_number}</td>
      <td className="hidden-xs">{member.email}</td>
      <td className="hidden-xs hidden-sm">{address}</td>
      <td className={classNames('text-right no-break hidden-xs hidden-sm', {
          'hidden': member.archived
        })}>
        <Button
          permission={member.permissions.write}
          className="btn btn-danger btn-xs"
          faName={'trash'}
          onClick={(e) => {deleteMember(e, member);}}>
          <span className="hidden-xs">{' Arkiver'}</span>
        </Button>
        {' '}
        <PermissionLink
          permission={member.permissions.write}
          to={'/klubb/' + member.club + '/medlem/' + member.id + '/rediger'}
          className="btn btn-xs btn-primary"
          faName="edit">
          <span className="hidden-xs">{' Rediger'}</span>
        </PermissionLink>
      </td>
      <td className={classNames('text-right no-break hidden-xs hidden-sm', {
          'hidden': !member.archived
        })}>
        <Button
          permission={member.permissions.write}
          className="btn btn-default btn-xs"
          faName={'undo'}
          onClick={(e) => {restoreMember(e, member.id);}}>
          <span className="hidden-xs">{' Gjennopprett'}</span>
        </Button>
      </td>
    </tr>
  );
};

// Note that this odd style is utilized for propType validation for now. Must be defined *after*
// the component is defined, which is why it's separate and down here.
ClubMemberRow.propTypes = {
  member: PropTypes.object.isRequired,
  deleteMember: PropTypes.func.isRequired,
  restoreMember: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default ClubMemberRow;



/** WEBPACK FOOTER **
 ** ./src/components/club/ClubMemberRow.js
 **/